import { render, staticRenderFns } from "./cookiePolicy.vue?vue&type=template&id=56ba7d9b&scoped=true"
import script from "./cookiePolicy.vue?vue&type=script&lang=js"
export * from "./cookiePolicy.vue?vue&type=script&lang=js"
import style0 from "./cookiePolicy.vue?vue&type=style&index=0&id=56ba7d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba7d9b",
  null
  
)

export default component.exports